export default __webpack_public_path__ + "static/media/upload-document.icon.54c65b7d.svg";